import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Card from '../components/card'
import Features23 from '../components/features23'
import Contact1 from '../components/contact1'
import Team1 from '../components/team1'
import Footer from '../components/footer'
import Support from '../components/support'
import { useTranslation } from 'react-i18next';
import './home.css'

const Home = (props) => {

  const { t, i18n } = useTranslation();
  const lngs = {
    en: { nativeName: 'English', imgSrc: '/images/flags/britain.png' },
    pt: { nativeName: 'Português', imgSrc: '/images/flags/portugal.png' },
    es: { nativeName: 'Português', imgSrc: '/images/flags/spain.png' }/*,
    fr: { nativeName: 'Português', imgSrc: '/images/flags/france.png' }*/
  };

  return (
    <div className="home-container1">
      <Helmet>
        <title>Do Smart - IT Consulting</title>
        <meta property="og:title" content="Do Smart - IT Consulting" />
      </Helmet>
      <header className="home-header1">
        <header data-thq="thq-navbar" className="home-navbar-interactive">
          <div className="home-branding1">
            <span className="home-text100">DO SMART</span>
            <svg viewBox="0 0 1024 1024" className="home-icon10">
              <path d="M128 128h768v768h-768z"></path>
            </svg>
            <span className="home-text101">IT Consulting</span>
          </div> 
          <div className="home-language-buttons">
            {Object.keys(lngs).map((lng) => (
              <button key={lng} className={`home-language-button ${i18n.resolvedLanguage === lng ? '' : 'inactive'}`} onClick={() => i18n.changeLanguage(lng)}>
                <img src={lngs[lng].imgSrc} alt={lngs[lng].nativeName} />
              </button>
            ))}
          </div>        
        </header>       
      </header>
      <header className="home-hero">
        <div className="home-content1">
          <img
            alt="image"
            src="/images/logo_regular_right_transparent_cropped.png"
            className="home-image10"
          />
          <h1 className="home-title1">{t('home.slogan')}</h1>
          <span className="home-description1">{t('home.description')}</span>
          <img alt="image" src="/images/curve-line.png" className="home-image11" />
        </div>
        <img
          alt="image"
          src="/images/main_logo.jpg"
          className="home-image12"
        />
      </header>


      
      <section className="home-mission1">
        <button className="home-button16 button">
          <span className="home-text108">Learn about our mission</span>
        </button>
        <h2 className="home-text109">{t('home.mission')}</h2>
      </section>
      <section id="services" className="home-services1">
        <h2 className="home-text118">{t('services.title')}</h2>
        <span className="home-text119">
          <span>{t('services.description')}</span>
          <br></br>
        </span>
        <div className="home-cards">
          <div className="home-row1">
            <Card
              icon="/images/icon-consulting.png"
              title={t('services.service1.title')}
              description={t('services.service1.description')}
            ></Card>
            <Card
              icon="/images/icon-support.png"
              title={t('services.service2.title')}
              description={t('services.service2.description')}
              rootClassName="cardroot-class-name"
            ></Card>
          </div>
          <div className="home-row2">
            <Card
              icon="/images/icon-software.png"
              title={t('services.service3.title')}
              description={t('services.service3.description')}
            ></Card>
            <Card
              icon="/images/icon-training.png"
              title={t('services.service4.title')}
              description={t('services.service4.description')}
            ></Card>
          </div>
        </div>
      </section>
      <Features23
        title={t('features.title')}
        heading1={
          <Fragment>
            <span className="home-text124 thq-heading-2">{t('features.title')}</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text123">{t('features.description')}</span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text125 thq-heading-2">
              <span>{t('features.feature1.title')}</span>
              <br></br>
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text138 thq-body-small">{t('features.feature1.description')}</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text128 thq-heading-2">
              <span>{t('features.feature2.title')}</span>
              <br></br>
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text139 thq-body-small">{t('features.feature2.description')}</span>
          </Fragment>
        }
        feature4Title={
          <Fragment>
            <span className="home-text131 thq-heading-2">
              <span>{t('features.feature3.title')}</span>
              <br></br>
            </span>
          </Fragment>
        }
        feature4Description={
          <Fragment>
            <span className="home-text140 thq-body-small">{t('features.feature3.description')}</span>
          </Fragment>
        }
        rootClassName="features23root-class-name"
        feature2Title1={
          <Fragment>
            <span className="home-text134 thq-heading-2">{t('features.feature4.title')}</span>
          </Fragment>
        }
        feature2Description1={
          <Fragment>
            <span className="home-text141 thq-body-small">{t('features.feature4.description')}</span>
          </Fragment>
        }
        feature3Title1={
          <Fragment>
            <span className="home-text135 thq-heading-2">{t('features.feature5.title')}</span>
          </Fragment>
        }
        feature3Description1={
          <Fragment>
            <span className="home-text142 thq-body-small">{t('features.feature5.description')}</span>
          </Fragment>
        }
        feature4Title1={
          <Fragment>
            <span className="home-text136 thq-heading-2">{t('features.feature6.title')}</span>
          </Fragment>
        }
        feature4Description1={
          <Fragment>
            <span className="home-text143 thq-body-small">{t('features.feature6.description')}</span>
          </Fragment>
        }
        feature3Title11={
          <Fragment>
            <span className="home-text137 thq-heading-2">{t('features.feature7.title')}</span>
          </Fragment>
        }
        feature3Description11={
          <Fragment>
            <span className="home-text144 thq-body-small">{t('features.feature7.description')}</span>
          </Fragment>
        }
      ></Features23>
      <Team1
        heading1={
          <Fragment>
            <span className="home-text177 thq-heading-2">{t('team.title')}</span>
          </Fragment>
        }
        heading2={
          <Fragment>
            <span className="home-text178 thq-heading-2">We’re hiring!</span>
          </Fragment>
        }
        actionContent={
          <Fragment>
            <span className="home-text186 thq-body-small">Open positions</span>
          </Fragment>
        }
        member1={
          <Fragment>
            <span className="home-text171 thq-body-small">{t('team.nunoperdigao.name')}</span>
          </Fragment>
        }        
        member1Job={
          <Fragment>
            <span className="home-text181 thq-body-small">{t('team.nunoperdigao.role')}</span>
          </Fragment>
        }
        member2Content22={
          <Fragment>
            <span className="home-text189 thq-body-small">{t('team.nunoperdigao.description')}</span>
          </Fragment>
        }
        member2={
          <Fragment>
            <span className="home-text172 thq-body-small">{t('team.ricardojorge.name')}</span>
          </Fragment>
        }
        member2Job={
          <Fragment>
            <span className="home-text182 thq-body-small">{t('team.ricardojorge.role')}</span>
          </Fragment>
        }
        member2Content23={
          <Fragment>
            <span className="home-text190 thq-body-small">{t('team.ricardojorge.description')}</span>
          </Fragment>
        }
        member3={
          <Fragment>
            <span className="home-text173 thq-body-small">{t('team.pedrosilva.name')}</span>
          </Fragment>
        }
        member3Job={
          <Fragment>
            <span className="home-text183 thq-body-small">{t('team.pedrosilva.role')}</span>
          </Fragment>
        }
        member2Content24={
          <Fragment>
            <span className="home-text191 thq-body-small">{t('team.pedrosilva.description')}</span>
          </Fragment>
        }
        member12={
          <Fragment>
            <span className="home-text179 thq-body-small">{t('team.joaoverdilheiro.name')}</span>
          </Fragment>
        }
        member1Job2={
          <Fragment>
            <span className="home-text184 thq-body-small">{t('team.joaoverdilheiro.role')}</span>
          </Fragment>
        }        
        member2Content21={
          <Fragment>
            <span className="home-text188 thq-body-small">{t('team.joaoverdilheiro.description')}</span>
          </Fragment>
        }
        member22={
          <Fragment>
            <span className="home-text180 thq-body-small">{t('team.brunoanastacio.name')}</span>
          </Fragment>
        }        
        member2Job2={
          <Fragment>
            <span className="home-text185 thq-body-small">{t('team.brunoanastacio.role')}</span>
          </Fragment>
        }
        member2Content2={
          <Fragment>
            <span className="home-text187 thq-body-small">{t('team.brunoanastacio.description')}</span>
          </Fragment>
        }        
        member32={
          <Fragment>
            <span className="home-text180 thq-body-small">{t('team.flaviogil.name')}</span>
          </Fragment>
        }        
        member3Job2={
          <Fragment>
            <span className="home-text185 thq-body-small">{t('team.flaviogil.role')}</span>
          </Fragment>
        }
        member3Content2={
          <Fragment>
            <span className="home-text187 thq-body-small">{t('team.flaviogil.description')}</span>
          </Fragment>
        }                
        member13={
          <Fragment>
            <span className="home-text180 thq-body-small">{t('team.antonioeusebio.name')}</span>
          </Fragment>
        }        
        member1Job3={
          <Fragment>
            <span className="home-text185 thq-body-small">{t('team.antonioeusebio.role')}</span>
          </Fragment>
        }
        member1Content3={
          <Fragment>
            <span className="home-text187 thq-body-small">{t('team.antonioeusebio.description')}</span>
          </Fragment>
        }
        member23={
          <Fragment>
            <span className="home-text180 thq-body-small">{t('team.bernardorodrigues.name')}</span>
          </Fragment>
        }        
        member2Job3={
          <Fragment>
            <span className="home-text185 thq-body-small">{t('team.bernardorodrigues.role')}</span>
          </Fragment>
        }
        member2Content3={
          <Fragment>
            <span className="home-text187 thq-body-small">{t('team.bernardorodrigues.description')}</span>
          </Fragment>
        }        
        member33={
          <Fragment>
            <span className="home-text180 thq-body-small">{t('team.ritaandrino.name')}</span>
          </Fragment>
        }        
        member3Job3={
          <Fragment>
            <span className="home-text185 thq-body-small">{t('team.ritaandrino.role')}</span>
          </Fragment>
        }
        member3Content3={
          <Fragment>
            <span className="home-text187 thq-body-small">{t('team.ritaandrino.description')}</span>
          </Fragment>
        }
        rootClassName="team1root-class-name"
      ></Team1>

      <Contact1
        heading={
          <Fragment>
            <span className="home-text161">{t('contacts.title')}</span>
          </Fragment>
        }
        emailTitle={
          <Fragment>{t('contacts.email.title')}</Fragment>
        } 
        email1={
          <Fragment>
            <span className="home-text159 thq-body-small">{t('contacts.email.address')}</span>
          </Fragment>
        } 
        content1={
          <Fragment>
            <span className="home-text168 thq-body-large">{t('contacts.email.description')}</span>
          </Fragment>
        }
        phoneTitle={
          <Fragment>{t('contacts.phone.title')}</Fragment>
        } 
        phone1={
          <Fragment>
            <span className="home-text160 thq-body-small">{t('contacts.phone.number')}</span>
          </Fragment>
        } 
        content2={
          <Fragment>
            <span className="home-text169 thq-body-large">{t('contacts.phone.description')}</span>
          </Fragment>
        }
        addressTitle={
          <Fragment>{t('contacts.address.title')}</Fragment>
        } 
        address1={
          <Fragment>
            <span className="home-text162 thq-body-small">
              <span>{t('contacts.address.line1')}<span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>{t('contacts.address.line2')}<span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>{t('contacts.address.line3')}</span>
            </span>
          </Fragment>
        }
        content3={
          <Fragment>
            <span className="home-text170 thq-body-large">{t('contacts.address.description')}</span>
          </Fragment>
        }
        rootClassName="contact1root-class-name"
      ></Contact1>
      
      <section className="home-galleries">
        <div className="home-gallery-desktop">
          <div className="home-column17">
            <img
              alt="image"
              src="/images/gallery1.jpg"
              className="home-image52"
            />
          </div>
          <div className="home-column18">
            <div className="home-row6">
              <div className="home-blue"></div>
              <img
                alt="image"
                src="/images/gallery3.jpg"
                className="home-image53"
              />
            </div>
            <div className="home-row7">
              <img
                alt="image"
                src="/images/gallery2.png"
                className="home-image54"
              />
              <div className="home-yellow2"></div>
            </div>
          </div>
        </div>
        <div className="home-gallery-mobile">
          <div className="home-column19">
            <img
              alt="image"
              src="/images/gallery1.jpg"
              className="home-image55"
            />
            <img
              alt="image"
              src="/images/gallery2.png"
              className="home-image56"
            />
          </div>
          <div className="home-column20">
            <div className="home-yellow3"></div>
            <img
              alt="image"
              src="/images/gallery3.jpg"
              className="home-image57"
            />
          </div>
        </div>
      </section>
      
      <Support></Support>

      <Footer></Footer>

      <div>
        <div className="home-container7">
          <Script
            html={`<style>
    .partner-container:hover .partner-image{
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(75deg) brightness(101%) contrast(102%);
    }
</style>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Home
